import React from "react";

const Header = ({
  Title,
  style,
}: {
  Title: string;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      style={{
        fontWeight: 700,
        fontSize: "14px",
        width: "auto",
        height: "20px",
      }}
    >
      {Title}
    </div>
  );
};

export default Header;
